module.exports = __webpack_public_path__ + "cc.svg?c4fddbc2164825d6bc6cada8b6057df8";